import IconEllipsis from "@shared/components/icons/Ellipsis"
import { Button } from "@shared/components/untitledui/base/buttons/button"
import { Dropdown } from "@shared/components/untitledui/base/dropdown/dropdown"
import { Tooltip } from "@shared/components/untitledui/base/tooltip/tooltip"
import { cx } from "@shared/components/untitledui/util/cx"
import type { Editor } from "@tiptap/core"
import { useEditorState } from "@tiptap/react"
import { MarkMenuItem } from "./MarkButton"
import { TOOLBAR_BUTTON_ACTIVE, TOOLBAR_BUTTON_CHROME } from "./toolbar-button-chrome"

// Marks surfaced through the overflow ("...") menu.
const extraMarks = ["superscript", "subscript"] as const

export function ExtraDropdownMenu({ editor }: { editor: Editor }) {
  const isActive = useEditorState({
    editor,
    selector: (snapshot) => extraMarks.some((type) => snapshot.editor.isActive(type)),
  })
  const canToggle = useEditorState({
    editor,
    selector: (snapshot) => extraMarks.some((type) => snapshot.editor.can().toggleMark(type)),
  })

  return (
    <Dropdown.Root>
      <Tooltip title="More formats" closeDelay={0}>
        <Button
          isDisabled={!canToggle}
          color="tertiary"
          size="xs"
          className={cx(TOOLBAR_BUTTON_CHROME, isActive && TOOLBAR_BUTTON_ACTIVE)}
          aria-label="More formats"
          iconLeading={<IconEllipsis />}
        />
      </Tooltip>
      <Dropdown.Popover placement="bottom">
        <Dropdown.Menu>
          <MarkMenuItem editor={editor} type="superscript" />
          <MarkMenuItem editor={editor} type="subscript" />
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown.Root>
  )
}
